import { Divider, TextField, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface VerifiedIdentitySectionProperties {
  fnr: string
  fnrSource: string | null | undefined
}

const VerifiedIdentitySection = ({
  fnr,
  fnrSource,
}: VerifiedIdentitySectionProperties) => {
  const { t } = useTranslation(['common'])

  const sourceName = fnrSource
    ? t(`guestRegisterWizardText.sourceName.${fnrSource}`)
    : ''
  const fromSourceLabel = fnrSource
    ? t(`guestRegisterWizardText.fnrFrom.${fnrSource}`)
    : ''

  return (
    <>
      <Typography variant="h2" sx={{ paddingTop: '1rem' }}>
        {t('guestRegisterWizardText.verifiedIdentityHeader')}
      </Typography>
      <Typography>
        {t('guestRegisterWizardText.verifiedIdentityBody', {
          source: sourceName,
        })}
      </Typography>
      <Divider sx={{ marginBottom: '1rem', border: '1px solid' }} />
      <TextField
        id="nationalIdNumber"
        label={t('input.nationalIdNumber')}
        value={fnr}
        disabled
        helperText={fromSourceLabel || undefined}
        inputProps={{
          'data-testid': 'verified-national-id-input',
        }}
      />
    </>
  )
}

export default VerifiedIdentitySection
